module.exports = __webpack_public_path__ + "static/img/contact-ewm.22d633d5.jpg";